import React, { PureComponent } from "react";
import TwoColumnsLayout from "../../layouts/two-columns";
import HelpIconButtonWithTooltipAndTypeformModal from "../../../typeform/HelpIconButtonWithTooltipAndTypeformModal";
import VerticalBarChart from "../../../ceo/analysis/competitive/charts/vertical-bar";
import TypeformContent from "../../../typeform/TypeformContent";
import TypeformLink from "../../../typeform/link";
import TypeformUrls from "../../../typeform/TypeformUrls";

class TeamReportsSection2Step6 extends PureComponent {
  getDataValue = (team_id, key) => {
    const { data } = this.props;

    if (!(team_id in data)) {
      return 0;
    }

    if (!(key in data[team_id])) {
      return 0;
    }

    let val = data[team_id][key];

    if (!val) {
      return 0;
    }

    return val;
  };

  get RNOA() {
    const { teams } = this.props;
    let data = [];

    Object.keys(teams).forEach(team_id => {
      const team = teams[team_id];
      data.push({
        name: team,
        value: this.getDataValue(team_id, "RNOA") * 100
      });
    });

    return data;
  }

  get left_content() {
    return (
      <span>
        Investors use RNOA to measure how well a business uses its operating
        assets to generate operating profits. The higher the RNOA, the better.
        Here is the formula:
        <br />
        <br />
        <div className="formula">
          RNOA =
          <div className="formula">
            AVERAGE OPERATING PROFITS
            <hr />
            OPERATING ASSETS
          </div>
        </div>
        <br />
        <br />
        To learn more about RNOA, please click here &rarr;
        <TypeformLink
          title="Return on Net Operating Assets"
          url={TypeformUrls.RNOA}
          className="link-with-margin"
        />
      </span>
    );
  }

  get right_content() {
    return (
      <div className="team-reports-valign-center">
        <VerticalBarChart suffix="%" data={this.RNOA} />
        <div className="text-center" style={{ marginTop: "-20px" }}>
          Return on Net Operating Assets
          <HelpIconButtonWithTooltipAndTypeformModal
            iconSize="xs"
            {...TypeformContent.RNOA_KPI}
          />
        </div>
      </div>
    );
  }

  render() {
    return (
      <TwoColumnsLayout
        title="Return on Net Operating Assets"
        left_content={this.left_content}
        right_content={this.right_content}
      />
    );
  }
}

export default TeamReportsSection2Step6;



// WEBPACK FOOTER //
// ./src/components/team-reports/steps/section-2/step-6.js